export default __webpack_public_path__ + "static/media/IconPenNibInactive.ecccf4b6.svg";